import{css}from'glamor';export var item=css({position:'relative',height:'100%'});